module.exports = __webpack_public_path__ + "static/media/house_success_left.e49ffa07.png";